import { CurveData, MotionSourceData } from '../data/FlyerData';
import { MuteMotionSource } from './MuteMotionSource';

const BezierEasing = require('bezier-easing');

/*

{
  l:0.25,
  cx: 0.5,
  cl: 0.25,
  cr: 0.25,
  r: 0.25
}

*/

export class BeatMotionSource extends MuteMotionSource {
  private _leftEasing: any = null;
  private _rightEasing: any = null;

  private _leftPointRightDistance: number = 0.25;

  private _centerPointX: number = 0.5;
  private _centerPointLeftDistance: number = 0.25;
  private _centerPointRightDistance: number = 0.25;

  private _rightPointLeftDistance: number = 0.25;

  constructor() {
    super();

    this.updateEasings();
  }

  populateWithData(data: MotionSourceData) {
    super.populateWithData(data);

    const beatData = data as CurveData;
    this._leftPointRightDistance = beatData.l;
    this._centerPointX = beatData.cx;
    this._centerPointLeftDistance = beatData.cl;
    this._centerPointRightDistance = beatData.cr;
    this._rightPointLeftDistance = beatData.r;
    this.updateEasings();
  }

  asData(): MotionSourceData {
    const result: CurveData = {
      ...super.asData(),
      l: this._leftPointRightDistance,
      cx: this._centerPointX,
      cl: this._centerPointLeftDistance,
      cr: this._centerPointRightDistance,
      r: this._rightPointLeftDistance
    };
    return result;
  }

  resetPoints() {
    this._leftPointRightDistance = 0.25;

    this._centerPointX = 0.5;
    this._centerPointLeftDistance = 0.25;
    this._centerPointRightDistance = 0.25;

    this._rightPointLeftDistance = 0.25;
    this.updateEasings();
    this._isCustom = false;
  }

  getLevelAt(millis: number, option: any = undefined): number {
    const position = (millis % this.getLoopDuration()) / this.getLoopDuration();
    const c = this._centerPointX;
    if (position === this.centerPointX) {
      return 1;
    } else if (position < c) {
      return this._leftEasing(position / c);
    } else {
      return 1 - this._rightEasing((position - c) / (1 - c));
    }
  }
  // Own

  get leftPointRightDistance(): number {
    return this._leftPointRightDistance;
  }
  set leftPointRightDistance(value: number) {
    this._leftPointRightDistance = value;
    this.updateEasings();
    this._isCustom = true;
  }

  get centerPointX(): number {
    return this._centerPointX;
  }
  set centerPointX(value: number) {
    this._centerPointX = value;
    this.updateEasings();
    this._isCustom = true;
  }
  get centerPointLeftDistance(): number {
    return this._centerPointLeftDistance;
  }
  set centerPointLeftDistance(v: number) {
    this._centerPointLeftDistance = v;
    this.updateEasings();
    this._isCustom = true;
  }
  get centerPointRightDistance(): number {
    return this._centerPointRightDistance;
  }
  set centerPointRightDistance(v: number) {
    this._centerPointRightDistance = v;
    this.updateEasings();
    this._isCustom = true;
  }

  get rightPointLeftDistance(): number {
    return this._rightPointLeftDistance;
  }
  set rightPointLeftDistance(v: number) {
    this._rightPointLeftDistance = v;
    this.updateEasings();
    this._isCustom = true;
  }

  private updateEasings() {
    this._leftEasing = null;
    this._rightEasing = null;
    if (this._centerPointX > 0) {
      this._leftEasing = BezierEasing(
        Math.min(this._centerPointX, this._leftPointRightDistance) /
          this._centerPointX,
        0,
        Math.max(0, this._centerPointX - this._centerPointLeftDistance) /
          this._centerPointX,
        1
      );
    } else {
      console.log('NOT CRATED LEFT EASING');
    }
    if (this._centerPointX < 1) {
      this._rightEasing = BezierEasing(
        Math.min(this._centerPointRightDistance, 1 - this._centerPointX) /
          (1 - this._centerPointX),
        0,
        (Math.max(1 - this._rightPointLeftDistance, this._centerPointX) -
          this._centerPointX) /
          (1 - this._centerPointX),
        1
      );
    } else {
      console.log('NOT CRATED RIGHT EASING');
    }
  }
}



// WEBPACK FOOTER //
// ./src/motion/BeatMotionSource.ts